<script setup lang="ts">
defineProps<{
  errors: Partial<Record<string, string[]>>;
}>();
</script>

<template>
  <div>
    <div
      v-for="errorKey in Object.keys(errors)"
      :key="errorKey"
    >
      <template v-for="error in (errors[errorKey] ?? [])" :key="error">
        <slot v-bind="{ errorKey, error }">
          {{ error }}
        </slot>
      </template>
    </div>
  </div>
</template>
